import { mapGetters, mapMutations, mapState } from 'vuex'
import track from '../../../components/track'

export default {
    data() {
        return {
            steps: {
                'one': 'stepOne',
                'two': 'stepTwo',
                // 'three': 'stepThree',
                'four': 'stepFour',
            },

            collapses: {
                'one': 'oneCollapse',
                'two': 'twoCollapse',
                // 'three': 'threeCollapse',
                'four': 'fourCollapse',
            },

            errorTitle: 'Errors',
            errors: null
        }
    },

    mounted() {
        this.$refs.oneCollapse.classList.add('in')

        /* ------------------------------
         * Uncomment for development
         * ------------------------------
        */
        // this.$refs.twoCollapse.classList.add('in')
        // // this.$refs.threeCollapse.classList.add('in')
        // this.$refs.fourCollapse.classList.add('in')

        this.resource = {
            store:  resource.store,
            thanks:  resource.thanks,
        }
    },

    methods: {
        analytics() {
            track.event({
                eventCategory: "phone",
                eventAction: "callmeback-contractació",
                eventLabel: ""
            })
        },

        forwardStepTwo() {
            if(!this.validateStepOne()) return

            this.trackStepOne()

            // show form step
            this.showStep('two')
            this.scrollToStep('two')
        },

        // forwardStepThree() {
        //     if(!this.validateStepOne()) return
        //     if(!this.validateStepTwo()) return
        //
        //     this.trackStepTwo()
        //
        //     // show confirmation step
        //     this.showStep('three')
        //     this.scrollToStep('three')
        // },

        async forwardSubmit() {
            if(!this.validateStepOne()) return
            if(!this.validateStepTwo()) return
            // if(!this.validateStepThree()) return

            // this.trackStepThree()
            this.trackStepTwo()

            // Show processing step
            this.showStep('four')
            this.scrollToStep('four')

            // Get form data
            let data = this.getOrderData()
            try {
                this.errorTitle = 'Errors'
                this.errors = null
                const res = await axios.post(this.resource.store, data);

                if(res.status !== 201){
                    // this.showStep('three')
                    // this.scrollToStep('three')
                    this.showStep('two')
                    this.scrollToStep('two')
                }
                let cell = 0;
                let net = 0;
                let energy = 0;
                if(data.products.cell.length > 0){
                    cell = 1;
                }
                if(data.products.net.length > 0){
                    net = 1;
                }
                if(data.products.energy.length > 0){
                    energy = 1;
                }
                // trackFbq('track', 'CompleteRegistration')
                // trackgtag()
                let fiscal_id = res.data.data.contact.fiscal_id ?? null
                window.location = this.resource.thanks+'?'+(new URLSearchParams({ fiscal_id: fiscal_id})).toString()
                    +'&'+(new URLSearchParams({ cell: cell})).toString()
                    +'&'+(new URLSearchParams({ net: net})).toString()
                    +'&'+(new URLSearchParams({ energy: energy})).toString()

            } catch (error) {
                console.error(error);
                this.errorTitle = error.response.data.message ?? 'Errors'
                this.errors = error.response.data.errors ?? null

                // this.showStep('three')
                // this.scrollToStep('three')
                this.showStep('two')
                this.scrollToStep('two')
            }
        },

        getOrderData() {
            return {
                products: this.serializeProducts,
                form: this.formFields,
                // confirmation: this.confirmationFields,
                selection: {
                    initialKey: this.productsSelection.initialKey,
                    initialPrice: this.productsSelection.initialPrice,
                    currentKey: this.productsSelection.currentKey,
                    currentPrice: this.price
                },
            }
        },

        backwardStepOne() {
            this.showErrorsOne(false)
            this.valid({ step: 'one', value: false })

            this.showErrorsTwo(false)
            this.valid({ step: 'two', value: false })

            // this.showErrorsThree(false)
            // this.valid({ step: 'three',  value: false })

            this.showErrorsFour(false)
            this.valid({ step: 'four',  value: false })

            this.showStep('one')
            this.scrollToStep('one')
        },

        backwardStepTwo() {
            if(!this.validateStepOne()) return

            this.showErrorsTwo(false)
            this.valid({ step: 'two', value: false })

            // this.showErrorsThree(false)
            // this.valid({ step: 'three',  value: false })

            this.showErrorsFour(false)
            this.valid({ step: 'four',  value: false })

            this.showStep('two')
            this.scrollToStep('two')
        },

        // backwardStepThree() {
        //     if(!this.validateStepOne()) return
        //     if(!this.validateStepTwo()) return
        //
        //     this.showErrorsThree(false)
        //     this.valid({ step: 'three',  value: false })
        //
        //     this.showErrorsFour(false)
        //     this.valid({ step: 'four',  value: false })
        //
        //     this.showStep('three')
        //     this.scrollToStep('three')
        // },

        validateStepOne() {
            this.valid({ step: 'one', value: this.productsIsValid })
            this.showErrorsOne(!this.productsIsValid)

            return this.productsIsValid
        },

        validateStepTwo() {
            this.updateRecaptchaValue() // copied from three...
            this.valid({ step: 'two', value: this.formIsValid })
            this.showErrorsTwo(!this.formIsValid)

            return this.formIsValid
        },

        // validateStepThree() {
        //     this.updateRecaptchaValue()
        //
        //     this.valid({ step: 'three',  value: this.confirmationIsValid })
        //     this.showErrorsThree(!this.confirmationIsValid)
        //
        //     return this.confirmationIsValid
        // },

        showStep(step) {

            if(step === 'two'){
                this.$refs.stepTwo.classList.add('in')
            }else {
                this.$refs.stepTwo.classList.remove('in')
            }

            $(this.$refs[this.collapses[step]]).collapse({
                parent: this.$refs.steps,
                toggle: false
            }).collapse('show')

            Object.keys(this.collapses).forEach((iStep) => {
                if(iStep !== step) this.active({ step: iStep, value: false })
                else this.active({ step: iStep, value: true })
            })
        },

        scrollToStep(step){
            let vm = this
            setTimeout(function(){
                let width = $(window).width();
                let offset = (width < 992) ? 110 : 70;

                $('html, body').animate({
                    scrollTop: $(vm.$refs[vm.steps[step]]).offset().top - offset
                }, 500);
            }, 500);
        },

        ...mapMutations( 'steps', [
            'valid',
            'active',
            'showErrors',
        ]),

        // ...mapMutations( 'confirmation', {
        //     setConfirmationField: 'setField',
        // }),
        ...mapMutations( 'form', {
            setFormField: 'setField',
        }),

        showErrorsOne(value) {
            if(value === false) this.showErrors({ step: 'one', value: false })
            else this.showErrors({ step: 'one', value: (+this.oneShowErrors) + 1 })
        },

        showErrorsTwo(value) {
            if(value === false) this.showErrors({ step: 'two', value: false })
            else this.showErrors({ step: 'two', value: (+this.twoShowErrors) + 1 })
        },

        // showErrorsThree(value) {
        //     if(value === false) this.showErrors({ step: 'three', value: false })
        //     else this.showErrors({ step: 'three', value: (+this.threeShowErrors) + 1 })
        // },

        showErrorsFour(value) {
            this.showErrors({ step: 'four',  value: value })
        },

        updateRecaptchaValue() {
            // this.setConfirmationField({
            //     name: 'recaptcha',
            //     value: document.querySelector('#g-recaptcha-response')?.value ?? null
            // })
            this.setFormField({
                name: 'recaptcha',
                value: document.querySelector('#g-recaptcha-response')?.value ?? null
            })
        },

        trackStepOne() {
            track.event({
                eventCategory: "orders",
                eventAction: "products-ok",
                eventLabel: this.getTrackingLabel()
            })
        },

        trackStepTwo() {
            track.event({
                eventCategory: "orders",
                eventAction: "form-ok",
                eventLabel: this.getTrackingLabel()
            })
        },

        // trackStepThree() {
        //     track.event({
        //         eventCategory: "orders",
        //         eventAction: "confirmation-ok",
        //         eventLabel: this.getTrackingLabel()
        //     })
        // },

        getTrackingLabel() {
            let key = this.productsSelection?.currentKey ?? 'UNKNOWN'
            let coverage = this.serializeProducts?.net[0]?.config?.coverage ?? 'NOT-DEFINED'
            let municipality = this.serializeProducts?.net[0]?.config?.municipality_name ?? 'NOT-DEFINED'

            return `${key}-[${coverage}]-[${municipality}]`
        }
    },

    computed: {
        ...mapGetters('products', {
            price: 'getPrice',
            formattedPrice: 'getFormattedPrice',
            serializeProducts: 'serializeProducts',
            productsIsValid: 'formIsValid',
            productsAreSelected: 'productsAreSelected',
            productConfigsAreValid: 'productConfigsAreValid',
        }),

        ...mapState('products', {
            currentConfig: state => state.currentConfig,
            productsSelection: state => state.selection,
        }),

        ...mapState('steps', {
            oneValid: state => state.one.valid,
            twoValid: state => state.two.valid,
            threeValid: state => state.three.valid,
            fourValid: state => state.four.valid,
            oneActive: state => state.one.active,
            twoActive: state => state.two.active,
            threeActive: state => state.three.active,
            fourActive: state => state.four.active,
            oneShowErrors: state => state.one.showErrors,
            twoShowErrors: state => state.two.showErrors,
            threeShowErrors: state => state.three.showErrors,
            fourShowErrors: state => state.four.showErrors,
        }),

        ...mapGetters('form', {
            formIsValid: 'formIsValid'
        }),

        ...mapState('form', {
            formFields: state => state.fields
        }),

        ...mapGetters('confirmation', {
            confirmationIsValid: 'confirmationIsValid'
        }),

        ...mapState('confirmation', {
            confirmationFields: state => state.fields
        }),
    }
}
